<template>
    <div class="hello">
        <h2>{{ vote.vote_name }}</h2>
        <div><img src="" alt=""></div>
        <div class="card">
            <div v-for="(v, v_index) in vote.problems" :key="v_index" class="card-body">
                <h5 class="card-title text-left">{{ v.problem }}</h5>
                <ul class="list-group list-group-flush" v-if="v.choose_type == '1'">
                    <el-radio-group v-model="radio">
                        <li v-for="(item, index) in v.options" :key="index" class="list-group-item text-left">
                            <el-radio :label="item.id">{{ item.option }}</el-radio>
                        </li>
                    </el-radio-group>
                </ul>

                <ul class="list-group list-group-flush" v-if="v.choose_type == '2'">
                    <el-checkbox-group v-model="radiolist">
                        <li v-for="(item, index) in v.options" :key="index" class="list-group-item text-left">
                            <el-checkbox :label="item.id">{{ item.option }}</el-checkbox>
                        </li>
                    </el-checkbox-group>
                </ul>
            </div>
            <div class="card-footer text-muted">
                <button class="btn btn-primary" @click="voteClick">投票</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Vote",
        props: {
            voteId: Number,
            articleId: Number,
        },
        data() {
            return {
                link: "https://yjsstatic.baidu.com/app/img/logo.svg",
                radio: 3,
                checkList: ["201", "202"],
                radio: '',
                radiolist: [],
                vote: {

                },
            };
        },
        mounted() {
            this.getvote()
        },
        methods: {
            getvote() {
                let that = this

                axios.post("/admin/Vote/voteRead", {
                        id: this.voteId
                    }, {
                        token: true
                    })
                    .then(response => {

                        this.vote = response.data.data
                        this.vote.problems.forEach(element => {
                            if (element.choose_type == 1) {
                                element.result = ''
                            } else {
                                element.result = []
                            }

                        });

                    })
                    .catch(error => {})
            },
            voteClick() {

            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>